import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Shows a small "new version available" toast when a fresh build has been
 * deployed and the service worker is waiting. Clicking Reload activates the
 * new version and refreshes — the user stays on the old version until they
 * choose to update (registerType: "prompt"), which avoids the mid-session
 * black-screen issue that auto-update caused.
 *
 * Mounted once at the app root. With vite-plugin-pwa's default injectRegister
 * ("auto"), importing useRegisterSW here means this hook owns SW registration.
 */
export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      // Re-check for a new build hourly so long-lived sessions still get
      // prompted without a manual page reload.
      if (registration) {
        setInterval(() => registration.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-lg border border-gold bg-surface px-4 py-3 shadow-2xl"
    >
      <span className="text-sm text-text">
        A new version of Nestd is available.
      </span>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        className="rounded-md bg-gold px-3 py-1 text-sm font-semibold text-black"
      >
        Reload
      </button>
    </div>
  );
}
